import * as React from "react";
import { Select } from "antd";
import { Countries, UnitedStates } from "../../../util/countries";
import {
  defaultSelectFilterOption,
  defaultSelectFilterSort,
} from "../../../util/utils";
import "./CountryDropdown.scss";

const { Option } = Select;

interface CountryDropdownProps {
  onChange: (value: string) => void;
  tabIndex?: number;
  defaultValue: string;
}

export default function CountryDropdown({
  onChange,
  tabIndex,
  defaultValue,
}: CountryDropdownProps) {
  return (
    <Select
      tabIndex={tabIndex}
      size={"large"}
      onChange={onChange}
      key={defaultValue}
      defaultValue={
        defaultValue === "United States" ? UnitedStates : defaultValue
      }
      className={"country-dropdown"}
      showSearch
      optionFilterProp="children"
      filterOption={defaultSelectFilterOption}
      filterSort={defaultSelectFilterSort}
    >
      <Option value={""} disabled={true}>
        Select Country
      </Option>
      {Countries.map((it) => (
        <Option key={it} value={it}>
          {it}
        </Option>
      ))}
    </Select>
  );
}
